// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_fragment_profile(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "IndividualAccountProfile",
    "TeamAccountProfile"
  ]);
}

let fragmentConverter = {"__root":{"profile_TeamAccountProfile_urlDetails":{"f":""},"profile_TeamAccountProfile_publicUrl":{"b":""},"profile_IndividualAccountProfile_urlDetails":{"f":""},"profile_IndividualAccountProfile_publicUrl":{"b":""},"profile":{"u":"fragment_profile"}}};

let fragmentConverterMap = {
  fragment_profile: unwrap_fragment_profile
};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, fragmentConverterMap, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: fragmentConverterMap,
  convertFragment: convertFragment
};

let Utils = {};

let node = ((function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "publicUrl",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "MarketingProfileURLDetails",
    "kind": "LinkedField",
    "name": "urlDetails",
    "plural": false,
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "CopyMarketingProfileLinkButton_urlDetails"
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UnifiedProfilePublicActions_account",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "profile",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": (v0/*: any*/),
            "type": "IndividualAccountProfile",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": (v0/*: any*/),
            "type": "TeamAccountProfile",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      "action": "THROW"
    }
  ],
  "type": "AccountV5",
  "abstractKey": null
};
})());

let wrap_fragment_profile = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_fragment_profile = unwrap_fragment_profile;
exports.wrap_fragment_profile = wrap_fragment_profile;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
